import { render, staticRenderFns } from "./rt1.vue?vue&type=template&id=38970072&scoped=true&"
import script from "./rt1.vue?vue&type=script&lang=js&"
export * from "./rt1.vue?vue&type=script&lang=js&"
import style0 from "./rt1.vue?vue&type=style&index=0&id=38970072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38970072",
  null
  
)

export default component.exports